var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgCoachDefault = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 104c-14.3 0-26.542-5.092-36.725-15.275S52 66.3 52 52s5.092-26.542 15.275-36.725S89.7 0 104 0s26.542 5.092 36.725 15.275S156 37.7 156 52s-5.092 26.542-15.275 36.725S118.3 104 104 104ZM0 208v-36.4c0-7.367 1.898-14.14 5.694-20.319 3.796-6.179 8.831-10.89 15.106-14.131 13.433-6.717 27.083-11.756 40.95-15.119A178.147 178.147 0 0 1 104 117c14.3 0 28.383 1.681 42.25 5.044 13.867 3.363 27.517 8.398 40.95 15.106 6.283 3.25 11.323 7.965 15.119 14.144 3.796 6.179 5.69 12.948 5.681 20.306V208H0Z",
    fill: "#F7F7F7"
  })));
};
export { SvgCoachDefault as ReactComponent };
export default __webpack_public_path__ + "3a811fd4b7b2ce749c1a12b2250d8e79.svg";